import ContentBlock from '../../ContentBlock';
import { DisclaimerContentBlock } from '../../DisclaimerContentBlock';
import loadable from '@loadable/component';
import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import { memo } from 'react';

const Rating = loadable(() => import('../../Rating'));
const NarrativeComment = loadable(() => import('../../NarrativeComment'));
const Announcement = loadable(() => import('../../Announcement'), {
  resolveComponent: (c) => c.Announcement,
});
const NarrativesRelated = loadable(() => import('../../NarrativesRelated'), {
  resolveComponent: (c) => c.NarrativesRelated,
});

type Props = {
  narrative: Narrative;
  commentRef: React.RefObject<HTMLDivElement>;
};

export const NarrativeMainContentBase = ({ narrative, commentRef }: Props) => {
  const {
    id: narrativeId,
    author,
    company,
    slug,
    contentBlocks,
    userHoldsPosition,
    announcements,
    commentKey,
  } = narrative;

  if (!company) throw new Error("Narrative's company is missing");

  const announcement = announcements?.at(-1);
  return (
    <article className="grid auto-rows-max gap-x2">
      {announcement && <Announcement slug={slug} announcement={announcement} />}
      {contentBlocks.map(({ contentHtml, title }, index) => (
        <ContentBlock key={`${title}-${index}`} contentHtml={contentHtml} />
      ))}
      {company && (
        <Rating
          companyId={company.id}
          narrativeId={narrativeId}
          uniqueSymbol={company.uniqueSymbol}
        />
      )}
      <NarrativeComment commentKey={commentKey} ref={commentRef} />

      <DisclaimerContentBlock
        userHoldsPosition={userHoldsPosition}
        authorDisplayName={author.displayName}
        companyTicker={company.uniqueSymbol}
        disclaimerType={author.disclaimerType}
      />

      <NarrativesRelated slug={slug} />
    </article>
  );
};

export const NarrativeMainContent = memo(NarrativeMainContentBase);
